<template>
  <div class="flipper-frame" :class="{ absolute: absolute, flip: flip }">
    <img v-lazy="imageUrl" :alt="alt" />
    <p>{{caption}}</p>
  </div>
</template>

<script>
export default {
  name: 'FlipperFrame',
  props: ['imageUrl', 'alt', 'caption', 'absolute', 'flip']
}
</script>

<style lang="scss" scoped>
.flipper-frame {
  width: 100%;
  box-sizing: border-box;
  border: 4px solid black;
  padding: 16px;
  margin-bottom: 4px;
  backface-visibility: hidden;
  transition: transform 750ms;
  transform: rotateY(0deg);
  background-color: white;

  &.absolute {
    position: absolute;
    left: 0;
    top: 0;
  }

  &.flip {
    transform: rotateY(180deg);
  }

  img {
    width: 100%;
  }

  p {
    font-family: 'Permanent Marker', cursive;
    font-size: 1em;
    text-align: center;
  }
}
</style>
